module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationKoreaHero.f5aef855.jpg";